module.exports = __webpack_public_path__ + "static/media/trash.d3589a49.svg";